import {
  Button,
  Flex,
  Form,
  FormInstance,
  Space,
} from 'antd'
import { Store } from 'antd/es/form/interface'
import React, {
  PropsWithChildren,
  useCallback,
  useState,
} from 'react'

import s from './table-search.module.css'

export interface TableSearchProps<Values> extends PropsWithChildren {
  initialValues?: Values
  onSearch: (values: Values | undefined, form: FormInstance<Values>) => Promise<void> | void
  showResetButton?: boolean
  showSearchButton?: boolean
}

export default function TableSearch<Values extends Store>({
  initialValues,
  onSearch,
  showResetButton = true,
  showSearchButton = true,
  children,
}: TableSearchProps<Values>) {
  const [form] = Form.useForm<Values>()
  const [submitting, setSubmitting] = useState(false)
  const submit = useCallback(async () => {
    try {
      setSubmitting(true)
      const values = await form.validateFields()
      await onSearch(values, form)
      setSubmitting(false)
    } catch (e) {
      console.warn('Submission error:', e)
      setSubmitting(false)
    }
  }, [onSearch, form])
  const onReset = useCallback(() => {
    form.resetFields()
    void onSearch(initialValues, form)
  }, [form, initialValues, onSearch])

  return (
    <Flex align="start" justify="space-between">
      <Form<Values>
        layout="inline"
        form={form}
        initialValues={initialValues}
        className={s.Form}
      >
        {children}
      </Form>
      <Space>
        {showResetButton && <Button onClick={onReset}>Reset</Button>}
        {showSearchButton && <Button type="primary" onClick={submit} loading={submitting}>Search</Button>}
      </Space>
    </Flex>
  )
}
